export class CoinFlightConstants {
    public static readonly SPINE_NAME: string = 'coin_flight';
    public static readonly WIDE_ANIMATION_NAME: string = 'wide_';
    public static readonly WIDE_PM_ANIMATION_NAME: string = 'widepm_';
}